import "../scss/dw-funcs.scss";
import fetchMorePosts from "./components/fetchMorePosts";

// wait until the window is fully loaded to run js
window.addEventListener("load", () => {// eslint-disable-line
  fetchMorePosts();
});
